module.exports = __webpack_public_path__ + "static/media/banserv.e61e3971.png";